var map = {
	"./avatar1.png": 8011,
	"./avatar10.png": 2159,
	"./avatar2.png": 8453,
	"./avatar3.png": 1587,
	"./avatar4.png": 1014,
	"./avatar5.png": 8704,
	"./avatar6.png": 9278,
	"./avatar7.png": 5075,
	"./avatar8.png": 7610,
	"./avatar9.png": 7302
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6834;